export default "__VITE_ASSET__Bv0y14d7__";